import { Col, Row } from 'antd'
import {
  CreditScoreSummary,
} from 'shared/components/CreditAndBackgroundCheck/interfaces'
import {
  CreditScoreChart,
  CreditScoreHeader,
  CreditScoreRating,
  CreditScoreTitle,
  Statistic,
} from 'shared/components/CreditAndBackgroundCheck/styled'
import {
  getFailedReportMessage,
  reportUnavailableTile,
  isVantageExclusion,
  reportExclusionTile,
} from 'shared/components/CreditAndBackgroundCheck/utils'
import Icon from 'shared/components/Icon'
import Spacer from 'shared/components/Spacer'
import Tile from 'shared/components/Tile'
import Tooltip from 'shared/components/Tooltip'
import { printDollarsFromCents } from 'shared/utils/dollar-print'
import { formatCreditScore } from 'shared/utils/ui'

type CreditScoreSectionProps = {
  creditScoreSummary?: CreditScoreSummary
  noSSNreasonToStay?: string
}

const CreditScoreSection = ({
  creditScoreSummary,
  noSSNreasonToStay,
}: CreditScoreSectionProps) => {
  const failedCreditReportMessage = getFailedReportMessage(creditScoreSummary)

  return (
    <Row gutter={14} type="flex">
        {!failedCreditReportMessage ? (
          <Col xs={24}>
            <Tile>
              <Tile.Inner>
                <CreditScoreHeader>
                  <CreditScoreTitle>
                    {noSSNreasonToStay && (
                      <div className="no-ssn-warning-icon">
                        <Tooltip title={noSSNreasonToStay}>
                          <Icon.OrangeExclamationSmall />
                        </Tooltip>
                      </div>
                    )}
                  </CreditScoreTitle>
                  <CreditScoreRating data-testid="credit-score-rating">
                    {formatCreditScore(creditScoreSummary?.score)}
                  </CreditScoreRating>
                  <CreditScoreChart score={creditScoreSummary?.score} />
                </CreditScoreHeader>
                <Spacer size={Spacer.SIZES.lg} hideLtXl />
                <Spacer hideGteXl />
                <Row gutter={[5, 0]}>
                  <Col md={4} xl={4}>
                    <Tile.Label>Credit Accounts</Tile.Label>
                    <Statistic bold data-testid="credit-accounts-count">
                      {creditScoreSummary?.accounts.length || 0}
                    </Statistic>
                  </Col>
                  <Col md={4} xl={4}>
                    <Spacer hideGteMd />
                    <Tile.Label>Total Credit Balance</Tile.Label>
                    <Statistic data-testid="credit-total-balance">
                      {printDollarsFromCents(creditScoreSummary?.creditBalance)}
                    </Statistic>
                  </Col>
                  <Col md={4} xl={4}>
                    <Spacer hideLtXl />
                    <Spacer hideGteMd />
                    <Tile.Label>Credit Limit</Tile.Label>
                    <Statistic data-testid="credit-limit">
                      {printDollarsFromCents(creditScoreSummary?.creditLimit)}
                    </Statistic>
                  </Col>
                  <Col md={4} xl={4}>
                    <Spacer hideLtXl />
                    <Spacer hideGteMd />
                    <Tile.Label>Percentage Available</Tile.Label>
                    <Statistic data-testid="credit-percentage-available">
                      {`${creditScoreSummary?.percentageAvailable || 0}%`}
                    </Statistic>
                  </Col>
                  <Col md={4} xl={4}>
                    <Spacer hideLtXl />
                    <Spacer hideGteMd />
                    <Tile.Label>Total Collections Amount</Tile.Label>
                    <Statistic>
                      {printDollarsFromCents(
                        creditScoreSummary?.totalCollectionsAmount,
                      )}
                    </Statistic>
                  </Col>
                </Row>
              </Tile.Inner>
            </Tile>
          </Col>
        ) : (
          isVantageExclusion(creditScoreSummary) ? (
            reportExclusionTile(failedCreditReportMessage)
          ) : (
            reportUnavailableTile('Credit Score', failedCreditReportMessage)
          )
        )}
    </Row>
  )
}

export default CreditScoreSection